module.exports = __webpack_public_path__ + "img/products.519c602a.svg";